import i18n from '@/plugins/i18n';

const processesMSGraphs = () => ({
  lineCharts: [
    {
      width: '49%',
      title: i18n.global.t('dbm.background-process-count'),
      header: {
        title: i18n.global.t('dbm.background-process-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_background_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.numberOfConnections'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.blocked-process-count'),
      header: {
        title: i18n.global.t('dbm.blocked-process-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_blocked_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.forced-parameterizations'),
      header: {
        title: i18n.global.t('dbm.forced-parameterizations'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_forced_parameterizations_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.parameterizations'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.runnable-processes-count'),
      header: {
        title: i18n.global.t('dbm.runnable-processes-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_runnable_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.runnable-tasks-count'),
      header: {
        title: i18n.global.t('dbm.runnable-tasks-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_runnable_tasks',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.running-process-count'),
      header: {
        title: i18n.global.t('dbm.running-process-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_running_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.sleeping-processes-count'),
      header: {
        title: i18n.global.t('dbm.sleeping-processes-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_sleeping_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('number-of-processes'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.suspended-processes-count'),
      header: {
        title: i18n.global.t('dbm.suspended-processes-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_suspended_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.size-in-bytes'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.transactions'),
      header: {
        title: i18n.global.t('dbm.transactions'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_transactions_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.transactions-minute'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.parameterizations-minute'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.sql-compilations'),
      header: {
        title: i18n.global.t('dbm.sql-compilations'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_stats_sql_compilations_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.compilations-minute'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.compilations-minute'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.sql-recompilations'),
      header: {
        title: i18n.global.t('dbm.sql-recompilations'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_stats_sql_recompilations_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.recompilations-minute'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.system-wait-time'),
      header: {
        title: i18n.global.t('dbm.system-wait-time'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_system_wait_time_in_milliseconds_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.ms-minute'),
      },
      showmetricRate: true,
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.avg-page-splits'),
      header: {
        title: i18n.global.t('dbm.avg-page-splits'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_access_page_splits_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.page-splits-minute'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('number-of-processes'),
      },
      showmetricRate: true,
    },
  ],
});
// const lineCharts = processesMSGraphs().lineCharts.map((chart) => ({
//   ...chart,
//   showmetricRate: true,
// }));

export default processesMSGraphs;
